<template>
  <div id="tl-root"> 

    <p class="my-0 py-0 text-center">
        <b>Este es el proceso que se sigue y el rol que lo ejecuta.</b> 
        <v-btn @click="togle_canvas()" text color="red" small title="ocultar grafica">X</v-btn>
    </p>
    <div ref="wrap" id="tl-canvas-wrap" v-show="ver_canvas">
      <canvas ref="canvas" id="tl-bg"></canvas>
      <div ref="nodes" id="tl-nodes"></div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    stages: [
      { name: "Contactar", role: "Asesor / formulario" },
      { name: "Prospectar", role: "Asesor" },
      { name: "Solicitar reg.", role: "Asesor" },
      { name: "Emitir recibos", role: "Area contable" },
      { name: "Terminos y condiciones", role: "Sistema, correo" },
      { name: "Preinscrito / Inscrito", role: "Sistema, según el pago" },
    ],

    currentStep: 2,
    isVertical: true,
    orientation: "vertical",

    animating: false,
    rafId: null,
    pathPoints: [],
    currentAnim: 0,
    // animacion inf
    loopTimer: null,
    isLooping: false,
    ver_canvas: true,
  }), 

  beforeDestroy() {
    this.stopLoop();
    window.removeEventListener("resize", this.handleResize);
},

  methods: {
    iniciar(currentStep = 2, isVertical = true) {
        this.stopLoop();
        window.removeEventListener("resize", this.handleResize);

        this.isVertical = isVertical;
        this.orientation = isVertical ? "vertical" : "horizontal";

        if (currentStep === -1) {
            this.currentStep = 0;
            this.currentAnim = 0;
            this.isLooping = true;

            this.$nextTick(() => {
                this.render(0);
                this.startLoop();
            });

            return;
        }

        this.currentStep = currentStep;
        this.currentAnim = this.targetFraction();

        this.$nextTick(() => {
            this.render(this.currentAnim);
        });
    },

    togle_canvas(){
      this.ver_canvas = !this.ver_canvas
    },

    handleResize() {
      this.render(this.currentAnim);
    },

    getIcon(type) {
      if (type === "completed") return "✓";
      if (type === "active") return "●";
      return "○";
    },

    stateForIndex(i) {
      if (i < this.currentStep) return "completed";
      if (i === this.currentStep) return "active";
      return "pending";
    },

    catmullRom(pts, t) {
      const n = pts.length;
      const segment = Math.min(Math.floor(t * (n - 1)), n - 2);
      const lt = t * (n - 1) - segment;

      const p0 = pts[Math.max(0, segment - 1)];
      const p1 = pts[segment];
      const p2 = pts[segment + 1];
      const p3 = pts[Math.min(n - 1, segment + 2)];

      const tt = lt;
      const tt2 = tt * tt;
      const tt3 = tt2 * tt;

      return {
        x:
          0.5 *
          ((2 * p1.x) +
            (-p0.x + p2.x) * tt +
            (2 * p0.x - 5 * p1.x + 4 * p2.x - p3.x) * tt2 +
            (-p0.x + 3 * p1.x - 3 * p2.x + p3.x) * tt3),

        y:
          0.5 *
          ((2 * p1.y) +
            (-p0.y + p2.y) * tt +
            (2 * p0.y - 5 * p1.y + 4 * p2.y - p3.y) * tt2 +
            (-p0.y + 3 * p1.y - 3 * p2.y + p3.y) * tt3),
      };
    },

    buildControlPoints(W, H, count, isVert) {
      const pts = [];
      const margin = isVert ? 45 : 45;
      const amplitude = isVert ? W * 0.22 : H * 0.12;

      for (let i = 0; i < count; i++) {
        const t = count === 1 ? 0.5 : i / (count - 1);
        let x;
        let y;

        if (isVert) {
          const cy = margin + t * (H - margin * 2);
          const side = i % 2 === 0 ? -1 : 1;

          x = W / 2 + side * amplitude * Math.sin(t * Math.PI);
          y = cy;
        } else {
          const cx = margin + t * (W - margin * 2);
          const side = i % 2 === 0 ? -1 : 1;

          x = cx;
          y = H / 2 + side * amplitude * Math.sin(t * Math.PI);
        }

        pts.push({ x, y });
      }

      return pts;
    },

    computePathPoints(controlPts, steps = 400) {
      const pts = [];

      for (let i = 0; i <= steps; i++) {
        pts.push(this.catmullRom(controlPts, i / steps));
      }

      return pts;
    },

    pathLengths(pts) {
      const lens = [0];

      for (let i = 1; i < pts.length; i++) {
        const dx = pts[i].x - pts[i - 1].x;
        const dy = pts[i].y - pts[i - 1].y;

        lens.push(lens[lens.length - 1] + Math.sqrt(dx * dx + dy * dy));
      }

      return lens;
    },

    pointAtFraction(pts, lens, frac) {
      const total = lens[lens.length - 1];
      const target = frac * total;

      let lo = 0;
      let hi = lens.length - 1;

      while (lo < hi - 1) {
        const mid = (lo + hi) >> 1;

        if (lens[mid] < target) lo = mid;
        else hi = mid;
      }

      const seg = (target - lens[lo]) / (lens[hi] - lens[lo]);

      return {
        x: pts[lo].x + seg * (pts[hi].x - pts[lo].x),
        y: pts[lo].y + seg * (pts[hi].y - pts[lo].y),
      };
    },

    getDimensions() {
        const wrap = this.$refs.wrap;
        const W = wrap.clientWidth || 640;

        const H = this.isVertical
            ? Math.max(260, this.stages.length * 75)
            : Math.max(180, this.stages.length * 40);

        return { W, H };
    },

    drawCurve(W, H, drawnFraction) {
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");
      const dpr = window.devicePixelRatio || 1;

      canvas.width = W * dpr;
      canvas.height = H * dpr;
      canvas.style.width = W + "px";
      canvas.style.height = H + "px";

      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, W, H);

      const pts = this.pathPoints;

      ctx.beginPath();
      pts.forEach((p, i) => {
        i === 0 ? ctx.moveTo(p.x, p.y) : ctx.lineTo(p.x, p.y);
      });

      ctx.strokeStyle = "#888780";
      ctx.lineWidth = 3;
      ctx.setLineDash([8, 8]);
      ctx.stroke();
      ctx.setLineDash([]);

      if (drawnFraction > 0) {
        const stopIdx = Math.floor(drawnFraction * (pts.length - 1));

        const grad = ctx.createLinearGradient(
          pts[0].x,
          pts[0].y,
          pts[stopIdx].x,
          pts[stopIdx].y
        );

        grad.addColorStop(0, "#3B6D11");
        grad.addColorStop(0.6, "#639922");
        grad.addColorStop(1, "#97C459");

        ctx.beginPath();

        for (let i = 0; i <= stopIdx; i++) {
          i === 0 ? ctx.moveTo(pts[i].x, pts[i].y) : ctx.lineTo(pts[i].x, pts[i].y);
        }

        ctx.strokeStyle = grad;
        ctx.lineWidth = 4;
        ctx.lineCap = "round";
        ctx.stroke();

        if (drawnFraction < 1) {
          const tipIdx = Math.min(stopIdx + 30, pts.length - 1);

          ctx.beginPath();

          for (let i = stopIdx; i <= tipIdx; i++) {
            i === stopIdx
              ? ctx.moveTo(pts[i].x, pts[i].y)
              : ctx.lineTo(pts[i].x, pts[i].y);
          }

          ctx.strokeStyle = "#C0DD97";
          ctx.lineWidth = 3;
          ctx.setLineDash([4, 4]);
          ctx.stroke();
          ctx.setLineDash([]);
        }
      }
    },

    placeNodes(W, H) {
      const container = this.$refs.nodes;

      container.innerHTML = "";
      container.style.width = W + "px";
      container.style.height = H + "px";

      const pts = this.pathPoints;
      const lens = this.pathLengths(pts);
      const n = this.stages.length;

      this.stages.forEach((stage, i) => {
        const frac = n === 1 ? 0.5 : i / (n - 1);
        const pos = this.pointAtFraction(pts, lens, frac);
        const state = this.stateForIndex(i);

        const node = document.createElement("div");
        node.className = "tl-node";
        node.style.left = pos.x + "px";
        node.style.top = pos.y + "px";

        const bubble = document.createElement("div");
        bubble.className = "tl-bubble " + state;

        if (state === "active") {
          const ring = document.createElement("div");
          ring.className = "tl-pulse-ring";
          bubble.appendChild(ring);
        }

        const icon = document.createElement("span");
        icon.className = "tl-check";
        icon.textContent = this.getIcon(state);

        bubble.appendChild(icon);

        const label = document.createElement("div");
        label.className = "tl-label " + state;

        label.innerHTML = `
          <div class="tl-label-name">${stage.name}</div>
          <div class="tl-label-role">${stage.role}</div>
        `;

        node.appendChild(bubble);
        node.appendChild(label);
        container.appendChild(node);
      });
    },

    render(drawnFraction) {
      if (!this.$refs.wrap || !this.$refs.canvas || !this.$refs.nodes) return;

      const { W, H } = this.getDimensions();
      const controlPts = this.buildControlPoints(
        W,
        H,
        this.stages.length,
        this.isVertical
      );

      this.pathPoints = this.computePathPoints(controlPts, 600);

      this.drawCurve(W, H, drawnFraction);
      this.placeNodes(W, H);
    },

    targetFraction() {
      const n = this.stages.length;

      if (n === 1) return 0;

      return this.currentStep / (n - 1);
    },

    nextStep() {
      if (this.currentStep < this.stages.length - 1) {
        this.currentStep++;
        this.playAnimation();
      }
    },

    prevStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
        this.currentAnim = this.targetFraction();
        this.render(this.currentAnim);
      }
    },

    setOrientation(val) {
      this.isVertical = val === "vertical";
      this.currentAnim = this.targetFraction();
      this.render(this.currentAnim);
    },

    playAnimation(done = null) {
        if (this.animating) return;

        const target = this.targetFraction();
        const start = this.currentAnim;

        if (Math.abs(target - start) < 0.001) {
            this.render(target);
            if (done) done();
            return;
        }

        const duration = Math.max(600, Math.abs(target - start) * 1800);
        let startTime = null;

        this.animating = true;

        const step = (ts) => {
            if (!startTime) startTime = ts;

            const elapsed = ts - startTime;
            const t = Math.min(elapsed / duration, 1);

            const ease =
            t < 0.5
                ? 4 * t * t * t
                : 1 - Math.pow(-2 * t + 2, 3) / 2;

            this.currentAnim = start + (target - start) * ease;
            this.render(this.currentAnim);

            if (t < 1) {
            this.rafId = requestAnimationFrame(step);
            } else {
            this.currentAnim = target;
            this.render(target);
            this.animating = false;

            if (done) done();
            }
        };

        this.rafId = requestAnimationFrame(step);
    },

    // animation inf
    startLoop() {
    if (!this.isLooping) return;

    this.loopTimer = setTimeout(() => {
        if (!this.isLooping) return;

        if (this.currentStep >= this.stages.length - 1) {
        this.currentStep = 0;
        this.currentAnim = 0;
        this.render(0);

        this.startLoop();
        return;
        }

        this.currentStep++;
        this.playAnimation(() => {
        this.startLoop();
        });
    }, 2000);
    },

    stopLoop() {
    this.isLooping = false;

    if (this.loopTimer) {
        clearTimeout(this.loopTimer);
        this.loopTimer = null;
    }

    if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
    }

    this.animating = false;
    },
  },
};
</script>

<style>
:root {
  --tl-completed: #3b6d11;
  --tl-completed-light: #eaf3de;
  --tl-completed-mid: #639922;
  --tl-active: #185fa5;
  --tl-active-light: #e6f1fb;
  --tl-active-mid: #378add;
  --tl-pending: #5f5e5a;
  --tl-pending-light: #f1efe8;
  --tl-pending-mid: #888780;
}

#tl-root {
  width: 100%; 
}

#tl-canvas-wrap {
  position: relative;
  width: 100%;
  overflow: hidden;
}

canvas#tl-bg {
  display: block;
  width: 100%;
}

#tl-nodes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 200px;
  pointer-events: none;
}

.tl-node {
  position: absolute;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: all;
  cursor: default;
}

.tl-bubble {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 500;
  border: 2.5px solid;
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
  z-index: 2;
}

.tl-bubble.completed {
  background: #eaf3de;
  border-color: #639922;
  color: #3b6d11;
}

.tl-bubble.active {
  background: #e6f1fb;
  border-color: #378add;
  color: #185fa5;
}

.tl-bubble.pending {
  background: #f1efe8;
  border-color: #888780;
  color: #5f5e5a;
}

.tl-node:hover .tl-bubble {
  transform: scale(1.15);
}

.tl-label {
  margin-top: 8px;
  text-align: center;
  background: #fff;
  border-radius: 8px;
  padding: 5px 10px;
  border: 0.5px solid rgba(0, 0, 0, 0.15);
  max-width: 130px;
  pointer-events: none;
}

.tl-label-name {
  font-size: 12px;
  font-weight: 500;
  color: #1a1a1a;
  line-height: 1.3;
}

.tl-label-role {
  font-size: 11px;
  color: #666;
  line-height: 1.3;
  margin-top: 2px;
}

.tl-label.completed .tl-label-name {
  color: #3b6d11;
}

.tl-label.active .tl-label-name {
  color: #185fa5;
}

.tl-pulse-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  transform: translate(-50%, -50%) scale(1);
  border: 2px solid #378add;
  opacity: 0;
  animation: pulse-ring 2s ease-out infinite;
  pointer-events: none;
  z-index: 1;
}

@keyframes pulse-ring {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.7;
  }

  100% {
    transform: translate(-50%, -50%) scale(2.2);
    opacity: 0;
  }
}

.tl-check {
  font-size: 20px;
} 

#tl-status {
  font-size: 12px;
  color: #666;
  padding: 0.5rem 1rem;
}
</style>